import styled from 'styled-components';

export const Div = styled.div`
  display: inline-flex;
  align-items: center;
  grid-gap: 8px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 85%;

  span {
    font-weight: 500;
    font-size: 13px;
  }
`;
